$(document).ready(() => {
	const $filters = $('.search-results__filters')
	const $filterClose = $('#filterClose', $filters)
	const $filterOpen = $('#catalog-filter > .button')

	$filterOpen.on('click touch', (e) => {
		e.preventDefault()
		$filters.addClass('open')
	})

	$filterClose.on('click touch', (e) => {
		e.preventDefault()
		$filters.removeClass('open')
	})

	$('.search--inline .search-results__articles').slick({
		dots: true,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					//centerMode: true,
					//centerPadding: '64px',
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			}
		]
	})

	// $(document).on('click touch', (e) => {
	// 	const $target = $(e.target)
	// 	if (!$target.closest('.search-results__filters:not(.open)').length && $filters.hasClass('open')) {
	// 		console.log('click outside open search filters')
	// 		// $filters.removeClass('open')
	// 	}
	// })

})
